import { isValidPhoneNumber } from "react-phone-number-input";
export const inputValidation = (value, yup = false, isContact = false) => {
  let err = {};
  // value = value ? value.replaceAll(" ", "") : "";
  // let inputStartsWith = value ? value.charAt(0) : 0;
  // let input_length = inputStartsWith == 6 ? 11 : 10;
  console.log("value yup:>> ", value);
  if (value == undefined || !value) {
    return {
      isError: true,
      phone: "Please Enter Mobile Number",
    };
  } else if (value && yup && !isValidPhoneNumber(value)) {
    console.log("heyyy");
    let message = `Please Enter Valid Mobile Number`;
    if (yup) {
      return yup.createError({
        message,
        path: "mobile", // Fieldname
      });
    } else {
      return {
        isError: true,
        phone: message,
      };
    }
  } else {
    console.log("else part yup:>> ");
    if (yup) {
      return true;
    } else {
      return err;
    }
  }
};
